import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores'; // Updated import path
import ViewProjectPage from './ViewProject';
import ViewUserPage from './ViewUser';
import { MenuItem } from '@mui/material';
import './style.scss';
import { OutlinedButton, TextInput, TextInputDropdown, PaginationControls,ItemsCountDisplay } from '../../../components';

const AtoZ = `${process.env.REACT_APP_CDN_URL}/globalAssets/A-ZFilter.svg`;
const ZtoA = `${process.env.REACT_APP_CDN_URL}/globalAssets/Z-AFilter.svg`;
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;

var mobile = require('is-mobile');

const Users = observer(() => {
    const { authStore, userStore, briefStore, projectStore, projectPlanStore, evaluationStore, quoteStore, uiStore } = useStore(); // Destructure all needed stores
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [ViewUser, setViewUser] = useState(false);
    const [ViewProject, setViewProject] = useState(false);
    const [UserMenu, setUserMenu] = useState(false);
    const [Users, setUsers] = useState([]);
    const [AddUser, setAddUser] = useState(false);
    const [SelectedUser, setSelectedUser] = useState('')
    const [Professionals, setProfessionals] = useState([]);
    const [Leads, setLeads] = useState([]);
    const [Pagination, setPagination] = useState({ 
            currentPage :  1, 
            hasMore     : false, 
            nextCursor  : "", 
            prevCursor  : "",
            pageSize    : 8, 
            totalPages  : 0, 
            totalUsers  : 0
    })
    const [NewUser, setNewUser] = useState({
        firstName: '',
        lastName: '',
        email: '',
        roles: [],
        phone: '',
        permissions: [],
        date: new Date(),
    });
    const [NameFilter, setNameFilter] = useState('A-Z');
    const [DateFilter, setDateFilter] = useState('A-Z');
    const [RoleFilter, setRoleFilter] = useState('A-Z');
    const [searchTerm, setSearchTerm] = useState('');
    const EmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const [Sortkey, setSorKey] = useState({
        Title: true,
        Department: false
    });

    useEffect(() => {
        getUsers("","ADMIN","");
    }, []);

    const getUsers = async (lastId, type, navId) => {
        uiStore.setLoading(true); // Use uiStore for loading state
        try {
            let Users = await userStore.getUsers(lastId, type, navId)
            if (Object.keys(Users).includes('pagination') && Object.keys(Users).includes('users')) {
                for (let i = 0; i < Users.users.length; i++) {
                    let usser = Users.users[i];
                    let userFullName = usser.firstName + ' ' + usser.lastName;
                    usser.fullName = userFullName;
                    if (Object.keys(usser).includes('roles') && Array.isArray(usser.roles)) {
                        for (let k = 0; k < usser.roles.length; k++) {
                            if (usser.roles[k] === 1987) {
                                usser['role'] = 'Admin';
                            };
                            if (usser.roles[k] === 1988) {
                                usser['role'] = 'Professional';
                            };
                            if (usser.roles[k] === 1989) {
                                usser['role'] = 'Client';
                            };
                        };
                    };
                };
                setUsers(Array.isArray(Users.users)?Users.users:[]);
                setPagination(Users.pagination??{ 
                    currentPage :  1,
                    hasMore     : false,
                    nextCursor  : "",
                    prevCursor  : "",
                    pageSize    : 8,
                    totalPages  : 0,
                    totalUsers  : 0
                });
                forceUpdate();
            }
        } catch (error) {
            console.error(error);
        } finally {
            uiStore.setLoading(false); // Use uiStore for loading state
        }
    };
    const handleViewUser = (id) => {
        let users = Users;
        let selectedPro = users.find(user => user._id === id);
        setSelectedUser(selectedPro);
        setViewUser(true);
        forceUpdate();
    };
   const handleSaveUser = async () => {
    try {
        uiStore.setLoading(true); // Start loading
        let user = NewUser;

        // Validate email
        let regexPass = EmailRegex.test(user.email);
        if (!regexPass) {
            uiStore.setLoading(false);
            uiStore.showNotification?.('Invalid email address', 'error'); // Show error notification
            return;
        }

        // Create user
        let result = await userStore.createUser(user);
        if (!result) {
            uiStore.showNotification?.('Error adding new user', 'error');
            uiStore.setLoading(false);
            return;
        }

        // Close add user popup
        setAddUser(false);

        // Show success notification instead of alert
        uiStore.showNotification?.('User added successfully', 'success');

        // Refresh user list
        getUsers("", "ADMIN", "");
        forceUpdate();
    } catch (e) {
        console.error(e);
        uiStore.showNotification?.('Something went wrong', 'error');
    } finally {
        uiStore.setLoading(false); // Stop loading
    }
};

    const handleUserDetailChange = (e) => {
        let user = NewUser;
        if (e.currentTarget.id === 'Name') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0];
            user.lastName = fullName.split(' ')[1];
        }
        if (e.currentTarget.id === 'ContactNumber') {
            user.phone = e.target.value;
        }
        if (e.currentTarget.id === 'Email') {
            user.email = e.target.value;
        }
        setNewUser(user);
        forceUpdate();
    };
    const handleOpenAddUser = () => {
        setAddUser(true);
        forceUpdate();
    };
    const handleCloseAddUser = () => {
        setAddUser(false);
        forceUpdate();
    };
    const handleUserMenu = () => {
        setUserMenu(true);
        forceUpdate();
    };
    const handleCloseUserMenu = () => {
        setUserMenu(false);
        forceUpdate();
    };
    const handleRoleChange = (e) => {
        let user = NewUser;
        user.roles = [e.target.value === 'Admin' || e.target.value === 'Fulfillment' ? 1987 : e.target.value === 'Client' ? 1989 : 1988];
        user.permissions = [];
        if (user.roles[0] === 1987) {
            user.permissions.push(
                'User_Create', 'User_View', 'User_Update', 'User_Get',
                'Client_Create', 'Client_View', 'Client_Update', 'Client_Get',
                'Professional_Create', 'Professional_View', 'Professional_Update', 'Professional_Get',
                'Brief_Create', 'Brief_View', 'Brief_Update', 'Brief_Get',
            )
        };
        if (user.roles[0] === 1989) {
            user.permissions.push(
                'Client_Create', 'Client_View', 'Client_Update', 'Client_Get',
                'Professional_View', 'Professional_Get',
                'Brief_Create', 'Brief_View', 'Brief_Update', 'Brief_Get',
            )
        };

        if (user.roles[0] === 1988) {
            user.permissions.push(
                'Client_View', 'Client_Get',
                'Professional_Create', 'Professional_View', 'Professional_Update', 'Professional_Get',
                'Brief_Create', 'Brief_View', 'Brief_Update', 'Brief_Get',
            )
        };
        setNewUser(user);
        forceUpdate();
    }
    const handlePageChange = (e) => {
        const ID  = e;

        if (ID === 'next' && Pagination.hasMore) {
            getUsers(Pagination.nextCursor, 'ADMIN', 'lastId');
        }else{
            if (Pagination.currentPage > 1) {
                getUsers(Pagination.prevCursor, 'ADMIN', 'prevId');
            }
        }
    };
    const backClicked = (back, isEdited) => {
        if (isEdited) {
            getUsers( "","ADMIN", "" );
        };
        setViewUser(back);
        forceUpdate();
    };
    const handleTitleFilterComps = (e) => {
        let users = Users
        let activeSortKey = Sortkey;
        let id = e.target.id;
        if (id === 'SortByTitle') {
            activeSortKey.Title = true;
            activeSortKey.Department = false;
            if (NameFilter === 'Z-A') {
                setNameFilter('A-Z');
                users.sort((a, b) => a.fullName.localeCompare(b.fullName));
            } else {
                setNameFilter('Z-A');
                users.sort((a, b) => b.fullName.localeCompare(a.fullName));
            };
        };
        if (id === 'SortByRole') {
            activeSortKey.Title = false;
            activeSortKey.Department = true;
            if (RoleFilter === 'Z-A') {
                setRoleFilter('A-Z');
            } else {
                setRoleFilter('Z-A');
            };
        };
        if (id === 'SortByDate') {
            activeSortKey.Title = false;
            activeSortKey.Department = true;
            if (DateFilter === 'Z-A') {
                setDateFilter('A-Z');
                users.sort((a, b) => {
                    if (!a.createdAt) return 1;
                    if (!b.createdAt) return -1;
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
            } else {
                setDateFilter('Z-A');
                users.sort((a, b) => {
                    if (!a.createdAt) return 1;
                    if (!b.createdAt) return -1;
                    return new Date(b.createdAt) - new Date(a.createdAt);
                });
            }
        };

        setSorKey(activeSortKey);
        forceUpdate();
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        forceUpdate();
    };
    const filteredUsers = Users.filter(user => {
        const searchValue = searchTerm.toLowerCase();
        return (String(`${user?.firstName ? user.firstName : user.companyName || ''}`).toLowerCase().includes(searchValue) || (user.email && user.email.toLowerCase().includes(searchValue)));
    });
    const formatDate = (inputDate) => {
        if (inputDate === undefined || !inputDate) {
            return `00/00/0000`
        }
        const date = new Date(inputDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    if (mobile()) {
        return (
            <div>
            </div>
        );
    } else {
        return (
            <div className='userPage'>
                <div className='userPageHeader'>
                    <p style={{ margin: '0px' }}>Users</p>
                    <img src={Credipple} alt='Credipple Logo' />
                </div>
                <div className='userPageBody'>
                    {(ViewProject) ?
                        <ViewProjectPage className='ViewProject-Container' /> :
                        (ViewUser) ?
                            <ViewUserPage 
                                backClick={(e, isEdited) => { backClicked(e, isEdited) }} 
                                selectedPro={SelectedUser} 
                                leads={Leads} 
                                pros={Professionals} 
                            />

                            :
                            <div className='usersList'>
                                <div className='userListHeader'>
                                    <div className='userListSection'>
                                        <p style={{ margin: '0px' }}>User list</p>
                                        {authStore.user.permissions.includes("User_Create") ? ( // Use authStore for user permissions
                                            <div className='openAddUser' onMouseEnter={handleUserMenu} onMouseLeave={handleCloseUserMenu}>...
                                                {(UserMenu) ?
                                                    <div className='userMenuOpen'>
                                                        <div className='AddUserConatiner'>
                                                            <img src={AddIcon} alt='Add User' onClick={handleOpenAddUser} />
                                                            <p onClick={handleOpenAddUser}>Add User</p>
                                                        </div>
                                                        <hr />
                                                    </div> : null}
                                            </div>
                                        ) : null}
                                    </div>
                                    {/* <div className='numofItems'>
                                        <p className='spancular'>{filteredUsers.length}</p>
                                    </div> */}
                                   <ItemsCountDisplay
                                    currentPage={Pagination.currentPage ?? 1}
                                    totalPages={Pagination.totalPages ?? 0}
                                    totalUsers={Pagination.totalUsers ?? 0} // <-- ensure not NaN
                                    pageSize={8}
                                    />

                                    <div className='search-bar-section' style={{ width: '25%', height: '60%' }}>
                                        <img src={SearchIcon} alt='Search Icon' />
                                        <input style={{ color: '#6D4194' }} placeholder='Search' value={searchTerm} onChange={handleSearchChange}></input>
                                    </div>
                                </div>
                                <div className='userListContent'>
                                    <div className='userListLabels'>
                                        <div className='userRoleSect'>
                                            <p style={{ margin: '0px', cursor: 'pointer' }} id='SortByTitle' onClick={handleTitleFilterComps}>User Name</p>
                                            <img src={NameFilter === 'A-Z' ? AtoZ : ZtoA} id='SortByTitle' style={{ cursor: 'pointer' }} onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='userRoleSect'>
                                            <p style={{ margin: '0px', cursor: 'pointer' }} id='SortByRole' onClick={handleTitleFilterComps}>User Role</p>
                                        </div>
                                        <div className='userDetails'>
                                            <p style={{ margin: '0px' }}>User Details</p>
                                        </div>
                                        <div className='dateCreatedsect'>
                                            <p style={{ margin: '0px', cursor: 'pointer' }} id='SortByDate' onClick={handleTitleFilterComps}>Date Created</p>
                                            <img src={DateFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='SortByDate' onClick={handleTitleFilterComps} />
                                        </div>
                                    </div>
                                   
                                    <div className='availableUsersSection'>
                                        {filteredUsers.map((item, index) => (
                                            <div className='availUsers' key={index}>
                                                <p className='availUserName'>{item.fullName}</p>
                                                <p className='availUserRole'>{Object.keys(item).includes('roles') && Array.isArray(item.roles) ? item.roles[0] === 1987 ? 'Admin' : item.roles[0] === 1988 ? 'Professional' : item.roles[0] === 1989 ? 'Client' : item.roles[0] : 'Not Assigned'}</p>
                                                <p className='availUserViewSec' style={{ margin: '0px' }} onClick={() => handleViewUser(item._id)}>View</p>
                                                <p style={{ margin: '0px', color: '#AFAFAF' }}>{formatDate(item.createdAt) || '00/00/0000'}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <PaginationControls
                                    currentPage={Pagination.currentPage}
                                   totalPages={Pagination.totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        }
                            
                </div>
                {(AddUser) ?
                    <div className='dashPopUp'>
                        <div className='addUserHeaderSection'>
                            <p>Create User</p>
                        </div>
                        <div className='addUserBodySection'>
                            <div className='topInputs'>
                                <TextInput className='userInfoFields' placeholder='Name & Surname' label='Name & Surname' id='Name' onChange={handleUserDetailChange}></TextInput>
                                <TextInput className='userInfoFields' placeholder='Contact Number' label='Contact Number' id='ContactNumber' onChange={handleUserDetailChange}></TextInput>
                            </div>
                            <div className='topInputs'>
                                <TextInput className='userInfoFields' placeholder='Email' label='Email' id='Email' onChange={handleUserDetailChange}></TextInput>
                                <TextInputDropdown className='userInfoFields' placeholder='Role' label='Role' id='Role' onChange={handleRoleChange}>
                                    <MenuItem value='Admin'>Admin</MenuItem>
                                    <MenuItem value='Client'>Client</MenuItem>
                                    <MenuItem value='Professional'>Professional</MenuItem>
                                    <MenuItem value='Fulfillment'>Fulfillment</MenuItem>
                                </TextInputDropdown>
                            </div>
                        </div>
                        <div className='addUserActionSection'>
                            <OutlinedButton className='cancelButton' onClick={handleCloseAddUser}>Cancel</OutlinedButton>
                            <OutlinedButton className='saveButton' onClick={handleSaveUser}>Save</OutlinedButton>
                        </div>
                    </div> : null}
            </div>
        )
    }
})

export default Users;